'use client';

import { Containers, Widgets } from '@components';
import { CompanySubnav } from '@/components/elements/CompanySubnav';

export default function PressPage() {
    return (
        <>
            <CompanySubnav currentLabel="Press" />
            <Containers.Section el={<Widgets.HeroOvalDivider color="brand-100" />} />
            <Containers.Section el={<Widgets.PressAndMedia />} />
            <Containers.Section el={<Widgets.PressKit />} />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}

